export type Role = 'admin' | 'manager' | 'cashier';

export const DISCOUNT_LIMITS: Record<Role, number> = {
  cashier: 30,
  manager: 50,
  admin: 100,
};

export const validateDiscount = (
  discount: number, 
  role: Role, 
  clientDiscount?: number
): { isValid: boolean; maxAllowed: number } => {
  // For cashier, allow discount up to client's discount value if client has discount
  if (role === 'cashier' && clientDiscount !== undefined && clientDiscount > 30) {
    const maxAllowed = Math.max(30, clientDiscount);
    if (discount > maxAllowed) {
      return {
        isValid: false,
        maxAllowed
      };
    }
    return {
      isValid: true,
      maxAllowed
    };
  }
  
  const maxAllowed = DISCOUNT_LIMITS[role];
  
  if (discount > maxAllowed) {
    return {
      isValid: false,
      maxAllowed
    };
  }
  
  return {
    isValid: true,
    maxAllowed
  };
};

export const getDiscountLimitForRole = (role: Role, clientDiscount?: number): number => {
  // For cashier, allow discount up to client's discount value if client has discount
  if (role === 'cashier' && clientDiscount !== undefined && clientDiscount > 30) {
    return Math.max(30, clientDiscount);
  }
  return DISCOUNT_LIMITS[role];
};

export const getDiscountValidation = (
  discountValue: number, 
  currentRole: Role, 
  clientDiscount?: number
) => {
  const validation = validateDiscount(discountValue, currentRole, clientDiscount);
  const maxDiscountAllowed = getDiscountLimitForRole(currentRole, clientDiscount);
  
  return { validation, maxDiscountAllowed };
};
